import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Button } from '../components/ui/button';
import { BreathingAura } from '../components/BreathingAura';
import { motion } from 'framer-motion';
import { toast } from 'sonner';

const Landing = () => {
  const { login } = useAuth();

  const handleLogin = async () => {
    try {
      await login();
    } catch (error) {
      toast.error('Login failed. Please try again.');
    }
  };

  return (
    <div className="min-h-screen relative overflow-hidden">
      <BreathingAura variant="calm" />
      
      <div className="relative z-10 container mx-auto px-6 py-16 md:py-24">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="max-w-4xl mx-auto text-center space-y-8"
        >
          <h1 className="text-6xl md:text-8xl font-serif font-light text-foreground tracking-tight">
            AURA
          </h1>
          
          <p className="text-xl md:text-2xl text-muted-foreground leading-relaxed max-w-2xl mx-auto">
            Your personal sanctuary for emotional well-being. Track your feelings, understand patterns, and find peace.
          </p>

          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.3, duration: 0.8 }}
            className="pt-8"
          >
            <Button
              data-testid="google-login-button"
              onClick={handleLogin}
              className="bg-primary text-primary-foreground hover:bg-primary/90 rounded-full px-12 py-8 text-xl transition-all hover:scale-105 active:scale-95 shadow-[0_0_30px_-5px_rgba(141,163,153,0.5)]"
            >
              Continue with Google
            </Button>
          </motion.div>

          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.6, duration: 0.8 }}
            className="pt-16 grid grid-cols-1 md:grid-cols-3 gap-8"
          >
            {[
              { title: 'Daily Check-ins', desc: 'Express how you feel, 3 times a day' },
              { title: 'AI Insights', desc: 'Personalized coping strategies & support' },
              { title: 'Emotional Trends', desc: 'Visualize your journey over time' },
            ].map((feature, i) => (
              <div
                key={i}
                className="bg-card/50 backdrop-blur-xl border border-white/5 rounded-3xl p-8 hover:border-white/10 transition-colors duration-500"
              >
                <h3 className="text-xl font-serif text-foreground mb-3">{feature.title}</h3>
                <p className="text-muted-foreground leading-relaxed">{feature.desc}</p>
              </div>
            ))}
          </motion.div>
        </motion.div>
      </div>
    </div>
  );
};

export default Landing;